export default __webpack_public_path__ + "static/media/roboto-latin-100italic.451d4e55.woff";